/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'reload': {
    width: 22,
    height: 23,
    viewBox: '0 0 22 23',
    data: `<path pid="0" d="M16.805 0l-.966 2.07L14 6l5-.814z"/><path pid="1" d="M20 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11h-2zm-9 9a9 9 0 0 1-9-9H0c0 6.075 4.925 11 11 11v-2zm-9-9a9 9 0 0 1 9-9V1C4.925 1 0 5.925 0 12h2zm17.588-2.7c.278.876.415 1.734.412 2.7h2a11.442 11.442 0 0 0-.504-3.3l-1.908.6zM11 3a8.554 8.554 0 0 1 4.05.96l.9-1.785A11.4 11.4 0 0 0 11 1v2z"/>`
  }
})
